module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form-panel', {
    directives: [{
      name: "display",
      rawName: "v-display",
      value: (true),
      expression: "true"
    }],
    ref: "form"
  }), _vm._v(" "), _c('coupon-panel', {
    ref: "couponPanel"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd85dbea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/act/promotionCouponBatch/ViewPanel.vue
// module id = 357
// module chunks = 0